export default __webpack_public_path__ + "static/media/ponto_3.7b5c66f9.svg";